import { contraceptionApi } from "@api";
import { ComponentBread, ComponentHeader, StyledCreateContraception } from "@components";
import { PATH_DEPO_RECORDS, PATH_CREATE_DEPO_RECORDS } from "@configs";
import { IContraceptionResponse } from "@interfaces";

import { setLoading } from "@redux";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router";
import { ContraceptionForm } from "@modules";

export const PageCreateRecord = () => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [contraception, setContraception] = useState<IContraceptionResponse>();
  useEffect(() => {
    if (id) {
      fetchContraceptionById();
    }
  }, [id]);
  const data = [
    {
      title: <a href={PATH_DEPO_RECORDS || ""}>{t('page.depo_and_ocpills_records')}</a>,
    },
    {
      title: <a href={PATH_CREATE_DEPO_RECORDS || ""}>{t('page.add_new_monthly_client')}</a>,
    },
  ];
  const fetchContraceptionById = async () => {
    try {
      dispatch(setLoading(true));
      const res = await contraceptionApi.getContraceptionById(id);
      setContraception(res.data);
    } catch (err: any) {
      history.push(PATH_DEPO_RECORDS);
      dispatch(setLoading(false));
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <>
      <ComponentHeader title={t("page.monthly_client_record_form")} />
      <StyledCreateContraception>
        <ComponentBread pages={data} />
        <ContraceptionForm contraception={contraception} />
      </StyledCreateContraception>
    </>
  );
};
